var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { resolve } from '@cvent/nucleus-dynamic-css';
import { injectTestId } from '@cvent/nucleus-test-automation';
import TimeZoneSwitchWidgetStyles from './TimeZoneSwitchWidget.less';
import Icon from '@cvent/nucleus-icon';
var TimeStyles = {
    classes: TimeZoneSwitchWidgetStyles
};
/**
 *
 * Time Zone switch widget shows in which time zone you are
 * currently viewing the event, for example
 * Viewing in Eastern Time etc.
 * It also provides the functionality to adjust your time zone
 *
 */
var TimeZoneSwitchWidget = function (props) {
    var translate = props.translate, switchTimeZone = props.switchTimeZone, instructionalTextStyles = props.instructionalTextStyles, showTimeZoneWidget = props.showTimeZoneWidget, selectedTimeZone = props.selectedTimeZone, eventTimeZone = props.eventTimeZone, hideAdjustTimeZone = props.hideAdjustTimeZone, isEventAndDeviceTimeZoneOffSetSame = props.isEventAndDeviceTimeZoneOffSetSame;
    var timeZone = 
    // eslint-disable-next-line @typescript-eslint/prefer-optional-chain
    selectedTimeZone && selectedTimeZone.nameResourceKey
        ? translate(selectedTimeZone.nameResourceKey)
        : translate(eventTimeZone.nameResourceKey);
    var timeZoneText = translate('Event_GuestSide_TimeZone_ViewText__resx', { timeZone: timeZone });
    return (React.createElement(React.Fragment, null, showTimeZoneWidget && (React.createElement("div", __assign({}, resolve(props, instructionalTextStyles), injectTestId('timeZoneWidget')),
        React.createElement(Icon, { icon: "time", modifier: TimeZoneSwitchWidgetStyles.timeIconSize }),
        timeZoneText,
        !hideAdjustTimeZone && !isEventAndDeviceTimeZoneOffSetSame && (React.createElement("span", __assign({ tabIndex: 0, role: "button" }, resolve(TimeStyles, 'switchStyle'), injectTestId('switchButton'), { onClick: switchTimeZone, onKeyPress: switchTimeZone }),
            React.createElement("u", null, translate('Event_GuestSide_SwitchText__resx'))))))));
};
export default TimeZoneSwitchWidget;
